import { Navigate, Route, Routes, useNavigate, useSearchParams } from 'react-router-dom';
import ConnectFlowPage from './pages/ConnectFlowPage';
import PricingPage from './pages/PricingPage';
import OnboardingInfoPage from './pages/OnboardingInfoPage';
import OnboardingPage from './pages/OnboardingPage';
import SettingsPage from './pages/SettingsPage';
import ClarityTracker from './components/ClarityTracker';

function App() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const shop = searchParams.get('shop') || '';
  const host = searchParams.get('host') || '';
  const hasEmbeddedContext = Boolean(shop && host);
  const isPaymentTestMode = searchParams.get('genseoTestPayment') === '1';

  const goToTestPaymentPage = () => {
    const nextParams = new URLSearchParams(searchParams);
    if (isPaymentTestMode) {
      nextParams.delete('genseoTestPayment');
    } else {
      nextParams.set('genseoTestPayment', '1');
    }
    const nextSearch = nextParams.toString();
    navigate({
      pathname: '/',
      search: nextSearch ? `?${nextSearch}` : '',
    });
  };

  if (!hasEmbeddedContext) {
    return (
      <main
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          padding: '24px',
          background: '#f6f6f7',
        }}
      >
        <section
          style={{
            maxWidth: '560px',
            width: '100%',
            background: '#fff',
            border: '1px solid #e1e3e5',
            borderRadius: '12px',
            padding: '20px',
          }}
        >
          <h1 style={{ margin: '0 0 8px', fontSize: '20px' }}>Open this app from Shopify Admin</h1>
          <p style={{ margin: 0, color: '#616161' }}>
            This embedded app requires Shopify context and OAuth session parameters. Please launch it from your Shopify
            admin Apps menu.
          </p>
        </section>
      </main>
    );
  }

  return (
    <>
      <ClarityTracker shop={shop} host={host} />
      <Routes>
        <Route path="/" element={<ConnectFlowPage />} />
        <Route path="/pricing" element={<PricingPage shop={shop} host={host} />} />
        <Route path="/onboarding-info" element={<OnboardingInfoPage shop={shop} host={host} />} />
        <Route
          path="/onboarding"
          element={<OnboardingPage shop={shop} host={host} onFinish={() => navigate('/', { replace: true })} />}
        />
        <Route path="/settings" element={<SettingsPage shop={shop} host={host} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {import.meta.env.DEV && (
        <button
          type="button"
          onClick={goToTestPaymentPage}
          style={{
            position: 'fixed',
            right: '16px',
            bottom: '16px',
            zIndex: 1000,
            border: 0,
            borderRadius: '8px',
            background: '#202223',
            color: '#fff',
            padding: '10px 14px',
            fontSize: '13px',
            fontWeight: 600,
            boxShadow: '0 6px 18px rgba(0, 0, 0, 0.18)',
            cursor: 'pointer',
          }}
        >
          {isPaymentTestMode ? 'Zurueck' : 'Payment testen'}
        </button>
      )}
    </>
  );
}

export default App;
